import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, currencyFormatter, getData } from '../CustomUtils'
import { MEDICARE_NEW_QUERY } from '../../../graphql.js'
import ParameterValues from '../ParameterValues.js'
import ResultsGrid from '../ResultsGrid.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportFooter from '../ReportFooter.js'
import TotalsRow from '../TotalsRow.js'

const MEDICARE_NEW = gql(MEDICARE_NEW_QUERY)

export default function MedicareNew({ location }) {
  console.log('MedicareNew rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, MEDICARE_NEW, 'medicareNew', setResults, setGraphQLErrors)
  }, [location])

  let totalSettlementAmount = 0

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const alignment = ['left', 'left', 'left', 'left', 'left', 'left', 'left', 'left', 'left', 'left', 'right', 'center', 'center', 'left']
    for (let i = 0; i < results.reportData.length; i++) {
      results.reportData[i][7] = results.reportData[i][7].replaceAll('&nbsp;', ' ')
    }
    let resultRows = ResultsGrid(results, 0, null, null, alignment, 12, currencyFormatter(), number => totalSettlementAmount += parseFloat(number))
    const parameterValues = ParameterValues(results)
    delete parameterValues[parameterValues.length-1] //removes report date from parameter values
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/medicareNew/report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Medicare Report - New 2023'} parameterValues={parameterValues} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <TotalsRow columnNumber={12} total={totalSettlementAmount} />
          </tbody>
        </Table>
        <ReportFooter>CONFIDENTIAL -- SUBJECT TO PROTECTIVE ORDER -- FOSTER WHEELER LITIGATION.</ReportFooter>
      </div>
    )
  }
}